export enum Datatype {
  DRIVE = 'drive',
  DEVICE_DATA = 'device',
  ARCHIVE = 'archive',
  TRASH = 'trash',
}
